import { IAppState } from '../../../AppModulesWrapper';
import { ECheckServiceStatus } from '../../types/reducers/checkoutInfo';

export function selectCheckServiceStatus(state: IAppState): ECheckServiceStatus {
  return state.servicePickerWidget.checkoutInfo.status;
}
